const otaUpdateBannerStrings = {
  message: 'A new version of Varo is ready. Reload to update.',
  reloadButton: 'Reload',
};

export default otaUpdateBannerStrings;
